<script lang="ts">
	export { classes as class };
	let classes = 'w-6 h-6';
</script>

<svg
	class={classes}
	width="24"
	height="24"
	viewBox="0 0 24 24"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		d="M11.17 3.24a1 1 0 0 1 1.66 0l1.12 1.67a1 1 0 0 0 1.11.4L17 4.75a1 1 0 0 1 1.27 1.07l-.22 2a1 1 0 0 0 .6 1.03l1.84.81a1 1 0 0 1 .28 1.64l-1.45 1.4a1 1 0 0 0-.2 1.15l.88 1.81a1 1 0 0 1-.83 1.44l-2 .14a1 1 0 0 0-.91.75l-.48 1.96a1 1 0 0 1-1.56.57l-1.63-1.19a1 1 0 0 0-1.18 0l-1.63 1.19a1 1 0 0 1-1.56-.57l-.48-1.96a1 1 0 0 0-.9-.75l-2.01-.14A1 1 0 0 1 4 15.66l.88-1.8a1 1 0 0 0-.2-1.17l-1.45-1.4a1 1 0 0 1 .28-1.63l1.85-.81a1 1 0 0 0 .59-1.03l-.22-2A1 1 0 0 1 7 4.75l1.94.56a1 1 0 0 0 1.1-.4l1.13-1.67Z"
		stroke="currentColor"
		stroke-width="1.5"
	/>
</svg>
